
import Vue from "vue";

export default Vue.extend({
  // NOTE: metaタグの設定
  metaInfo: {
    meta: [
      {
        name: "robots",
        content: "none",
      },
    ],
  },
  data() {
    return {
      page: "",
    };
  },
  created() {
    window.scrollTo(0, 0);

    if (this.$route.path.includes("/subscription")) {
      this.page = "subscription";
    } else if (this.$route.path.includes("/unsubscription")) {
      this.page = "unsubscription";
    }
  },
});
